import React, { useCallback, useState } from "react";

import { ReactComponent as ErrorInfo } from "../../../Assets/Images/Error.svg";
import { ReactComponent as Info } from "../../../Assets/Images/Info.svg";
import { ReactComponent as Success } from "../../../Assets/Images/Success.svg";
import { PasswordInput } from "../../atoms/Input/PasswordInput";
import { Text1 } from "../../atoms/Typography/Text/Text";
import { InformationBox } from "../InformationBox/InformationBox";
import PasswordIndicator from "../PasswordIndicator/PasswordIndicator";
import { FormItemsWrap } from "../Wrap/Wrap";

export const PasswordStrengthField = ({
  control,
  label,
  name,
  password,
  InformationBoxWidth,
  t,
  isInherit,
}) => {
  const [showIndicator, setShowIndicator] = useState(false);
  const criteriaPassed = useCallback(() => {
    const uppercaseRegex = /[A-Z]/.test(password);
    const lowercaseRegex = /[a-z]/.test(password) && password !== undefined;
    const digitRegex = /\d/.test(password);
    const lengthRegex = /^.{8,}$/.test(password);

    const countOfTrueValues = [
      uppercaseRegex,
      lowercaseRegex,
      digitRegex,
      lengthRegex,
    ].reduce((count, currentValue) => {
      return currentValue ? count + 1 : count;
    }, 0);

    return {
      uppercaseRegex,
      lowercaseRegex,
      digitRegex,
      lengthRegex,
      countOfTrueValues,
    };
  }, [password]);

  return (
    <FormItemsWrap>
      <PasswordInput
        required={true}
        control={control}
        label={label}
        name={name}
        isInherit={isInherit != undefined ? isInherit : true}
        onClick={() => setShowIndicator(true)}
      />
      {showIndicator && (
        <PasswordIndicator t={t} count={criteriaPassed().countOfTrueValues} />
      )}
      {showIndicator && (
        <InformationBox
          width={InformationBoxWidth}
          title={t("validation:password-length")}
          children={
            <>
              <Text1
                text={t("validation:have-uppercase-character")}
                icon={
                  criteriaPassed().uppercaseRegex ? (
                    <Success role="img" type="img" aria-label="Success Icon" />
                  ) : !criteriaPassed().uppercaseRegex && password ? (
                    <ErrorInfo />
                  ) : (
                    <Info role="img" type="img" aria-label="Info Icon" />
                  )
                }
              />
              <Text1
                text={t("validation:have-lowercase-character")}
                icon={
                  criteriaPassed().lowercaseRegex ? (
                    <Success role="img" type="img" aria-label="Success Icon" />
                  ) : !criteriaPassed().lowercaseRegex && password ? (
                    <ErrorInfo />
                  ) : (
                    <Info role="img" type="img" aria-label="Info Icon" />
                  )
                }
              />
              <Text1
                text={t("validation:have-one-digit")}
                icon={
                  criteriaPassed().digitRegex ? (
                    <Success role="img" type="img" aria-label="Success Icon" />
                  ) : !criteriaPassed().digitRegex && password ? (
                    <ErrorInfo />
                  ) : (
                    <Info role="img" type="img" aria-label="Info Icon" />
                  )
                }
              />
            </>
          }
        />
      )}
    </FormItemsWrap>
  );
};
